"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dropdownIndicator = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var dropdownIndicator = function dropdownIndicator(provided, state) {
  var isMulti = state.isMulti,
      selectProps = state.selectProps,
      theme = state.theme;
  return isMulti ? _objectSpread(_objectSpread({}, provided), {}, {
    paddingRight: '0.75rem',
    paddingLeft: 0,
    '.indicator': {
      display: 'inline-block',
      width: '0.625rem',
      height: '1.1875rem',
      color: selectProps.menuIsOpen ? 'var(--color-flomni-blue-70)' : theme.arrowColor,
      transform: selectProps.menuIsOpen ? 'rotate(180deg)' : 'rotate(0deg)',
      verticalAlign: 'middle',
      transition: 'transform 150ms'
    },
    '.counter': {
      display: 'inline-block',
      padding: '0.1875rem 0.3125rem',
      color: 'var(--color-flomni-blue-70)',
      backgroundColor: 'var(--color-flomni-blue-10)',
      borderRadius: '0.125rem',
      marginRight: '0.6875rem',
      fontSize: '0.75rem',
      fontWeight: 400,
      lineHeight: '0.8125rem',
      textAlign: 'center',
      boxSizing: 'border-box',
      minWidth: '1.0625rem',
      '&:hover': _objectSpread(_objectSpread({}, provided['&:hover']), {}, {
        color: 'var(--color-flomni-blue-70)'
      })
    }
  }) : _objectSpread(_objectSpread({}, provided), {}, {
    width: '0.75rem',
    height: '0.75rem',
    boxSizing: 'content-box',
    padding: '0.625rem',
    color: selectProps.menuIsOpen ? 'var(--color-flomni-blue-70)' : theme.arrowColor,
    transform: selectProps.menuIsOpen ? 'rotate(180deg)' : 'rotate(0deg)',
    transition: 'transform 150ms',
    '&:hover': _objectSpread(_objectSpread({}, provided['&:hover']), {}, {
      color: 'var(--color-flomni-blue-70)'
    })
  });
};

exports.dropdownIndicator = dropdownIndicator;